"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { SEXVR_CHANNELS } from "@/lib/sexvr-channels"
import { useTranslations } from "next-intl"

const ORDERS = ["newest", "most-viewed"] as const

interface SexvrFilterTabsProps {
  channel: string
  order: string
  onChannelChange: (value: string) => void
  onOrderChange: (value: string) => void
}

// SexVR's channels (anal, blonde, teen...) and its most-viewed list; see lib/booru-sources/booru-api/sexvr.ts. The order applies to the
// plain feed: a channel, tag or search is listed in the site's own order.
export function SexvrFilterTabs({ channel, order, onChannelChange, onOrderChange }: SexvrFilterTabsProps) {
  const t = useTranslations("sexvrFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[
        { id: "channel", label: t("channel"), value: channel, defaultValue: "all", options: [{ value: "all", label: t("allChannels") }, ...SEXVR_CHANNELS.map((c) => ({ value: String(c.id), label: c.label }))] },
        { id: "order", label: t("order"), value: order, defaultValue: "newest", options: ORDERS.map((value) => ({ value, label: t(value) })) },
      ]}
      onChange={(id, value) => (id === "channel" ? onChannelChange(value) : onOrderChange(value))}
    />
  )
}
